"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clampInLoop = void 0;
/**
 * Clamps and loop a number in a range.
 *
 * This is used to convert a number that may move infinitely in either direction
 * (positive or negative) into a valid index in a range. When the number becomes larger than the last index in the array it
 * will be converted to an index that loops back around to the beginning of the
 * array. When the number becomes smaller than the minimum number (the first index in the
 * array) it will be converted to an index that loops forward to the end of the
 * array.
 */

const clampInLoop = (index, min, max) => index > max ? min : index < min ? max : index;
exports.clampInLoop = clampInLoop;